var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import { defaultBaseProps } from './defaults';
import Line from './Line';
import Circle from './Circle';
import { validProgress } from './common';
import { WrongFilled, SuccessFilled, DeleteFunc, CheckMarkFunc } from '@feb-team/legao-icons-react';
import { SpanTag } from '../../Utils/AtomicTag';
var Progress = /** @class */ (function (_super) {
    __extends(Progress, _super);
    function Progress(props) {
        var _this = _super.call(this, props) || this;
        _this.render = function () {
            var _a = _this.props, type = _a.type, percent = _a.percent, rest = __rest(_a, ["type", "percent"]);
            var progressInfo = _this.renderProcessInfo();
            if (type === 'line') {
                return (React.createElement(Line, __assign({ name: Progress.NAME, percent: validProgress(percent) }, rest), progressInfo));
            }
            else if (type === 'circle') {
                return (React.createElement(Circle, __assign({ name: Progress.NAME, percent: validProgress(percent) }, rest), progressInfo));
            }
            else {
                console.warn('您设置的type类型不存在');
            }
        };
        return _this;
    }
    Progress.prototype.textFormatter = function (percentNumber) {
        return percentNumber + "%";
    };
    Progress.prototype.renderProcessInfo = function () {
        var _a = this.props, showInfo = _a.showInfo, type = _a.type, percent = _a.percent, status = _a.status;
        if (!showInfo)
            return null;
        var progressAtomics = [
            'inline-block',
            'whitespace-no-wrap',
            'text-gray-600',
            'text-center',
            'break-normal',
            'align-middle',
            'ml-2',
        ];
        var progressAtomicsLeft = [
            'inline-block',
            'whitespace-no-wrap',
            'text-gray-600',
            'w-full',
            'text-center',
            'break-normal',
            'align-middle',
            'flex',
            'justify-center',
            'align-middle',
        ];
        var text;
        var isLineType = type === 'line';
        if (status !== 'exception' && status !== 'success') {
            text = this.textFormatter(validProgress(percent));
        }
        else if (status === 'exception') {
            text = isLineType ? (React.createElement(WrongFilled, { style: { color: '#E1251B' } })) : (React.createElement(DeleteFunc, { style: { color: '#E1251B' } }));
        }
        else if (status === 'success') {
            text = isLineType ? (React.createElement(SuccessFilled, { style: { color: '#3EBF17' } })) : (React.createElement(CheckMarkFunc, { style: { color: '#3EBF17' } }));
        }
        return (React.createElement(SpanTag, { atomics: isLineType ? progressAtomics : progressAtomicsLeft, style: { fontSize: '1em' } }, text));
    };
    Progress.NAME = 'progress';
    Progress.displayName = 'Progress';
    Progress.defaultProps = defaultBaseProps;
    return Progress;
}(Component));
export { Progress };
